// avstemming-vat-messages translations (English catalog).
window.PlummeI18n.register('en', {
  'avf.common.matches': 'Matches',
  'avf.common.submitted': 'Submitted',
  'avf.common.notSubmitted': 'Not submitted',
  'avf.common.complete': 'Complete',
  'avf.common.differences': '{count} difference(s)',
  'avf.common.difference': 'Difference',
  'avf.common.needsAssessment': 'Needs assessment',
  'avf.common.status': 'Status',
  'avf.common.all': 'All',
  'avf.common.missingTreatment': 'VAT treatment not determined',
  'avf.common.directPosting': 'Direct posting',
  'avf.common.postedDirectly': 'Posted directly to VAT account',
  'avf.common.noDeduction': 'No right of deduction',
  'avf.common.partialDeduction': 'Partial right of deduction',
  'avf.common.reverseCharge': 'Reverse charge',
  'avf.common.salesWithoutVat': 'Sales without VAT',
  'avf.common.creditNotes': 'Credit notes',
  'avf.common.assessed': 'Assessed',
  'avf.common.salesOutgoing': 'Sales and output VAT',
  'avf.common.purchasesIncoming': 'Purchases and input VAT',
  'avf.common.sales': 'Sales',
  'avf.common.purchases': 'Purchases',
  'avf.common.foreign': 'Abroad',
  'avf.common.assess': 'Assess',
  'avf.common.viewAssessment': 'View assessment',
  'avf.common.requestDocs': 'Ask the client for documentation',
  'avf.common.close': 'Close',
  'avf.common.followUpNext': 'Follow up next period',
  'avf.common.missing': 'Missing',
  'avf.common.outgoingInTerm': 'Output VAT in the period',
  'avf.common.incomingInTerm': 'Input VAT in the period',
  'avf.common.filingDeadline': 'Filing deadline',
  'avf.common.reportingPeriod': 'Reporting period',
  'avf.common.documentation': 'Documentation',
  'avf.common.filingTitle': 'VAT return',
  'avf.common.col.document': 'Document',
  'avf.common.col.documentDate': 'Document date',
  'avf.common.col.account': 'Account',
  'avf.common.col.vatCode': 'VAT code',
  'avf.common.col.vatAmount': 'VAT amount',
  'avf.common.col.rate': 'Rate',
  'avf.common.col.warning': 'Warning',
  'avf.common.col.assessment': 'Assessment',
  'avf.common.col.counterparty': 'Counterparty',
  'avf.common.col.type': 'Type',
  'avf.common.col.basis': 'Basis',
  'avf.common.col.date': 'Date',
  'avf.common.col.amount': 'Amount',
  'avf.common.col.deductionRate': 'Deduction rate',
  'avf.term.monthly': 'Monthly',
  'avf.term.bimonthly': 'Every two months',
  'avf.term.quarterly': 'Quarterly',
  'avf.term.semiannual': 'Semi-annual',
  'avf.term.annual': 'Annual',
  'avf.assess.notAssessed': 'Not assessed',
  'avf.assess.noCorrection': 'No correction needed',
  'avf.assess.missingCode': 'Missing VAT code',
  'avf.assess.wrongCode': 'Wrong VAT code',
  'avf.assess.wrongRate': 'Wrong rate',
  'avf.assess.limitedDeduction': 'Limited right of deduction',
  'avf.assess.importVat': 'Import VAT',
  'avf.assess.wrongTerm': 'Reported in the wrong period',
  'avf.assess.duplicate': 'Duplicate',
  'avf.assess.awaitingDocs': 'Awaiting documentation',
  'avf.assess.awaitingClient': 'Awaiting the client',
  'avf.page.noAccount': 'The VAT area has no reconciliation account in this period.',
  'avf.page.nav.overview': 'Overview',
  'avf.page.nav.codes': 'VAT codes and basis',
  'avf.page.nav.codesCount': '{count} codes',
  'avf.page.nav.toAssess': '{count} to assess',
  'avf.page.nav.foreign': 'Abroad and import',
  'avf.page.nav.items': '{count} items',
  'avf.page.nav.accounts': 'VAT accounts',
  'avf.page.nav.accountsCount': '{count} accounts',
  'avf.page.nav.filing': 'VAT return and settlement',
  'avf.page.nav.deviations': 'Deviations and actions',
  'avf.page.nav.open': '{count} open',
  'avf.page.nav.missing': '{count} missing',
  'avf.page.nav.controls': 'Control and approval',
  'avf.page.areaFallback': 'VAT',
  'avf.page.hintOpen': '{count} transaction(s) with warnings have not been fully assessed.',
  'avf.page.hintDone': 'All transactions with warnings have been assessed.',
  'avf.page.title': 'VAT — transaction basis, general ledger and VAT return',
  'avf.page.reconciledIn': 'Reconciled in {period}',
  'avf.page.responsible': 'Responsible: {name}',
  'avf.page.notRegisteredBadge': 'Not VAT-registered',
  'avf.page.termOver': 'The period has ended',
  'avf.page.termRunning': 'The period is running',
  'avf.page.orgNumber': 'Organization number',
  'avf.page.termLength': 'Period length',
  'avf.page.netInTerm': 'Net VAT in the period',
  'avf.page.termNotOver': 'The period has not ended.',
  'avf.page.termEnds': '{period} {year} ends {date}, and the VAT reconciliation belongs in that month.',
  'avf.page.termSoFar': 'The figures below show the period so far. The area does not count toward progress in this period.',
  'avf.page.notRegistered': 'The business is not registered in the VAT register in the settings. If VAT has still been posted in the period, it is the registration or the bookkeeping that must be corrected, not the reconciliation.',
  'avf.ov.sources.title': 'Data sources',
  'avf.ov.sources.incompleteOne': '{count} source is not complete for the period.',
  'avf.ov.sources.incompleteMany': '{count} sources are not complete for the period.',
  'avf.ov.sources.allPresent': 'All the sources the reconciliation reads are in place for the period.',
  'avf.ov.sources.colSource': 'Source',
  'avf.ov.sources.colDetails': 'Details',
  'avf.ov.sources.notComplete': 'Not complete',
  'avf.ov.main.title': 'Automatic main reconciliation',
  'avf.ov.main.noAccounts': 'No VAT accounts to compare',
  'avf.ov.main.codesMatch': 'The VAT codes match the general ledger',
  'avf.ov.main.noActivity': 'The period has no activity on the VAT accounts. Without an account to compare with, there is no difference to reconcile.',
  'avf.ov.main.sameTax': 'The tax that follows from the VAT codes is the same as what has been posted to the VAT accounts in the period.',
  'avf.ov.main.differentTax': 'The tax that follows from the VAT codes is not the same as what has been posted to the VAT accounts. The difference must be explained before the area can be reconciled.',
  'avf.ov.main.colArea': 'Control area',
  'avf.ov.main.colCodes': 'VAT codes',
  'avf.ov.main.colLedger': 'General ledger',
  'avf.ov.main.notCompared': 'Not compared',
  'avf.ov.codes.title': 'VAT codes and reporting basis',
  'avf.ov.codes.none': 'No VAT codes with amounts in this period.',
  'avf.ov.codes.explain': 'The basis is the transactions in the period. Computed VAT is the basis multiplied by the rate — if it differs from the code\'s own amount, the tax has been calculated on something other than the basis.',
  'avf.ov.codes.colDescription': 'Description',
  'avf.ov.codes.colComputed': 'Computed VAT',
  'avf.ov.codes.colBooked': 'Posted VAT',
  'avf.ov.codes.noRate': 'No rate',
  'avf.ov.accounts.title': 'VAT accounts in the general ledger',
  'avf.ov.accounts.none': 'No VAT account has a balance or activity in this period.',
  'avf.ov.accounts.colAccount': 'Control account',
  'avf.ov.accounts.colOpening': 'Opening balance',
  'avf.ov.accounts.colDebit': 'Debit',
  'avf.ov.accounts.colCredit': 'Credit',
  'avf.ov.accounts.colClosing': 'Closing balance',
  'avf.ov.accounts.colExpected': 'Computed from VAT codes',
  'avf.ov.accounts.carriedOver': 'Not cleared from the previous period',
  'avf.ov.accounts.noCodePoints': 'No code points here',
  'avf.ov.accounts.open': 'Open account',
  'avf.ov.accounts.sumOutgoing': 'Total output VAT in the period',
  'avf.ov.accounts.sumIncoming': 'Total input VAT in the period',
  'avf.ov.accounts.bookedOn': 'Posted to {accounts}',
  'avf.ov.accounts.carriedNote': '{codes}: the balance has not been cleared after the previous period. Check whether the amount relates to a settlement that has not been paid, or to a posting error.',
  'avf.ov.tile.duplicateVouchers': 'Possible duplicate vouchers',
  'avf.ov.tile.customsMissing': 'Customs declaration missing',
  'avf.ov.tile.creditNotesInPeriod': 'Credit notes in the period',
  'avf.ov.card.title': 'Control card',
  'avf.ov.card.summary': '{flagged} affected transactions · {unassessed} not fully assessed',
  'avf.ov.card.codesVsLedger': 'VAT codes vs. general ledger',
  'avf.ov.card.seeMain': 'See the main reconciliation',
  'avf.ov.card.settlementNotCleared': 'Settlement account not cleared',
  'avf.ov.card.hide': 'Hide',
  'avf.ov.card.showAll': 'Show all automatic checks',
  'avf.ov.card.activeFilter': 'Active filter: {label} · {count} transactions',
  'avf.ov.card.reset': 'Reset',
  'avf.ov.checks.title': 'Automatic checks',
  'avf.ov.checks.note': 'The checks do not tick anything in the professional checklist. They say what the person ticking should have looked at.',
  'avf.ov.checks.colCheck': 'Check',
  'avf.ov.checks.colRun': 'Run',
  'avf.ov.checks.colFindings': 'Findings',
  'avf.ov.checks.run': 'Run',
  'avf.ov.checks.findings': '{count} findings',
  'avf.ov.checks.noFindings': 'No findings',
  'avf.tbl.possibleDuplicates': 'Possible duplicates',
  'avf.tbl.duplicates': 'Duplicates',
  'avf.tbl.foreignReverse': 'Abroad/reverse charge',
  'avf.tbl.import': 'Import',
  'avf.tbl.sales.totalBasis': 'Total sales basis',
  'avf.tbl.sales.taxableTurnover': 'Taxable turnover',
  'avf.tbl.sales.outputVat': 'Output VAT',
  'avf.tbl.sales.toAssess': 'Transactions to assess',
  'avf.tbl.sales.colCustomer': 'Customer',
  'avf.tbl.sales.colNetBasis': 'Net basis',
  'avf.tbl.sales.noMatch': 'No sales transactions match the filters.',
  'avf.tbl.sales.none': 'No sales in this period.',
  'avf.tbl.purchases.totalBasis': 'Total purchase basis',
  'avf.tbl.purchases.deductedInputVat': 'Deducted input VAT',
  'avf.tbl.purchases.withoutDeduction': 'Without right of deduction',
  'avf.tbl.purchases.partialDeduction': 'Partial deduction',
  'avf.tbl.purchases.toAssess': 'Purchases to assess',
  'avf.tbl.purchases.colSupplier': 'Supplier',
  'avf.tbl.purchases.noMatch': 'No purchase transactions match the filters.',
  'avf.tbl.purchases.none': 'No purchases in this period.',
  'avf.tbl.control.title': 'Transaction control',
  'avf.tbl.control.resetFilters': 'Reset filters',
  'avf.tbl.control.noMatch': 'No transactions match the filters.',
  'avf.tbl.control.none': 'No transactions with VAT effect in this period.',
  'avf.sec.status.paid': 'Submitted and paid',
  'avf.sec.status.unpaid': 'Submitted — not paid',
  'avf.sec.status.upcoming': 'The period has not started',
  'avf.sec.status.archive': 'Archive basis from import',
  'avf.sec.status.unknown': 'Unknown status',
  'avf.sec.noFlags': 'None',
  'avf.sec.moreFlags': '+{count} more',
  'avf.sec.customs.registered': 'Registered',
  'avf.sec.customs.notRelevant': 'Not relevant',
  'avf.sec.foreign.title': 'Abroad, import and reverse charge',
  'avf.sec.foreign.none': 'No purchases with reverse charge or goods imports in this period.',
  'avf.sec.foreign.count': 'Number of foreign transactions',
  'avf.sec.foreign.reverseBasis': 'Basis for reverse charge',
  'avf.sec.foreign.computedOutput': 'Computed output VAT',
  'avf.sec.foreign.deductibleInput': 'Deductible input VAT',
  'avf.sec.foreign.customsRegistered': 'Customs declarations registered',
  'avf.sec.foreign.customsMissing': 'Customs declarations missing',
  'avf.sec.foreign.colOutput': 'Output VAT',
  'avf.sec.foreign.colInput': 'Input VAT',
  'avf.sec.foreign.colCustoms': 'Customs document',
  'avf.sec.foreign.missingOne': 'One goods import has no registered customs declaration in the period. The import basis then cannot be checked against anything, and the import VAT rests only on the posted amount.',
  'avf.sec.foreign.missingMany': '{count} goods imports have no registered customs declaration in the period. The import basis then cannot be checked against anything, and the import VAT rests only on the posted amount.',
  'avf.sec.foreign.requestCustoms': 'Ask the client for the customs declaration',
  'avf.sec.draft.titleSubmitted': 'Summary of the VAT return',
  'avf.sec.draft.titleDraft': 'Summary of the VAT return (draft)',
  'avf.sec.draft.badge': 'Draft',
  'avf.sec.draft.totalOutput': 'Total output VAT',
  'avf.sec.draft.totalDeductible': 'Total input VAT for deduction',
  'avf.sec.draft.importReverse': 'VAT on import and reverse charge',
  'avf.sec.draft.importIncomplete': 'Not complete — see Abroad and import',
  'avf.sec.draft.netRefund': 'Net VAT refundable',
  'avf.sec.draft.netPayable': 'Net VAT payable',
  'avf.sec.draft.deviation': 'Deviation from the VAT model\'s figure for the period',
  'avf.sec.draft.submittedNote': 'The return has been submitted. The reconciliation checks that the basis behind it is correct.',
  'avf.sec.draft.notSentNote': 'The return has not been sent — the amount may change once the control findings have been handled.',
  'avf.sec.filing.noTerm': 'The period does not belong to any VAT term in {year}.',
  'avf.sec.filing.yearFallback': 'the year',
  'avf.sec.filing.covers': 'The period covers',
  'avf.sec.filing.netRefund': 'Net refundable',
  'avf.sec.filing.netToPay': 'Net payable',
  'avf.sec.filing.submittedNote': 'The return has been submitted for the period. The reconciliation checks that the basis behind it is correct.',
  'avf.sec.filing.notSubmittedNote': 'The return has not been submitted. It is sent from the client\'s own VAT page — the reconciliation concludes, it does not report.',
  'avf.sec.filing.declarations': '{count} customs declaration(s) registered in the period.',
  'avf.sec.settle.title': 'Settlement and payment',
  'avf.sec.settle.refundAmount': 'Refund amount',
  'avf.sec.settle.claim': 'Claim according to the return',
  'avf.sec.settle.refunded': 'Refunded',
  'avf.sec.settle.paid': 'Paid',
  'avf.sec.settle.outstanding': 'Outstanding',
  'avf.sec.settle.paymentDeadline': 'Payment deadline',
  'avf.sec.settle.refundRow': 'Refund',
  'avf.sec.settle.paymentRow': 'Payment',
  'avf.sec.settle.noPayment': 'No payment has been registered for the period yet.',
  'avf.sec.settle.cannotFinish': 'The settlement cannot be completed until the return has been submitted and the payment registered.',
  'avf.sec.docs.colUploaded': 'Uploaded',
  'avf.sec.docs.sourceClient': 'The client',
  'avf.sec.docs.sourceFirm': 'The firm',
  'avf.sec.docs.none': 'No documents have been uploaded to the VAT area for this period.',
  'avf.sec.docs.incompleteBasis': 'Basis that is not complete',
  'avf.chk.derived.missingTreatment': 'Transactions without determined VAT treatment have been handled',
  'avf.chk.derived.direct': 'Direct postings to the VAT accounts have been assessed',
  'avf.chk.derived.duplicates': 'Possible duplicates have been assessed',
  'avf.chk.derived.noDeduction': 'Purchases without right of deduction have been assessed',
  'avf.chk.derived.partialDeduction': 'Purchases with partial right of deduction have been assessed',
  'avf.chk.derived.reverseCharge': 'Reverse charge has been assessed',
  'avf.chk.derived.customsMissing': 'Goods imports without a customs declaration have been handled',
  'avf.chk.derived.salesWithoutVat': 'Sales without VAT are documented',
  'avf.chk.derived.creditNotes': 'The period allocation of credit notes has been assessed',
  'avf.chk.title': 'Professional checklist',
  'avf.chk.titleReadOnly': 'Professional checklist (the performer\'s, read-only)',
  'avf.chk.none': 'No control points are defined for VAT in this period.',
  'avf.chk.note': 'The points apply to the whole VAT area. A tick is saved on all the VAT accounts in the period.',
  'avf.chk.groupItems': 'Items that require handling',
  'avf.chk.groupAssessments': 'Overall professional assessments',
  'avf.chk.groupReady': 'Readiness',
  'avf.chk.countOf': '{done} of {total}',
  'avf.chk.processed': '{done} of {total} handled',
  'avf.chk.notApplicable': 'Not applicable this period',
  'avf.chk.followsAssessments': 'Follows from the assessments',
  'avf.chk.performedBy': 'Performed by {name}',
  'avf.chk.completed': '{done} of {total} control points completed',
  'avf.chk.blk.itemsOne': '{count} transaction requires assessment',
  'avf.chk.blk.itemsMany': '{count} transactions require assessment',
  'avf.chk.blk.diff': 'The VAT codes and the general ledger differ on {areas}',
  'avf.chk.blk.settlement': 'The settlement account has not been cleared from the previous period',
  'avf.chk.blk.customs': '{count} goods import(s) missing a customs declaration',
  'avf.chk.blk.checksOne': '{count} control point remains',
  'avf.chk.blk.checksMany': '{count} control points remain',
  'avf.chk.concl.title': 'Conclusion and approval',
  'avf.chk.concl.label': 'Conclusion',
  'avf.chk.concl.placeholder': 'What does the review of VAT show for this period?',
  'avf.chk.concl.savedAs': 'Saved as the justification on the control point "{label}".',
  'avf.chk.concl.remainingRisk': 'Remaining risk',
  'avf.chk.concl.nothingLeft': 'Nothing remains that prevents the area from being sent to control.',
  'avf.chk.concl.followUpTitle': 'Follow-up next period',
  'avf.chk.concl.noFollowUps': 'No assessments are marked for follow-up next period.',
  'avf.chk.concl.followedUp': 'Followed up',
  'avf.chk.concl.action': 'Action: {action}',
  'avf.chk.concl.noAction': 'No action noted',
  'avf.chk.concl.due': 'Deadline {date}',
  'avf.chk.concl.openAssessment': 'Open assessment',
  'avf.chk.concl.sendToControl': 'Send the area to control',
  'avf.chk.concl.oneLeft': 'One thing remains before the area can be sent.',
  'avf.chk.concl.manyLeft': '{count} things remain before the area can be sent.',
  'avf.drw.outputReverse': 'Output VAT (reverse)',
  'avf.drw.reason': 'Professional justification',
  'avf.drw.reasonRequired': 'Professional justification (required)',
  'avf.drw.reasonPlaceholder': 'Why has the tax been treated this way, and what is the assessment based on?',
  'avf.drw.action': 'Action',
  'avf.drw.actionPlaceholder': 'E.g. Correct the VAT code on the voucher, or ask for documentation',
  'avf.drw.followUpDeadline': 'Follow-up deadline',
  'avf.drw.needsReason': 'This assessment requires a justification.',
  'avf.drw.save': 'Save assessment',
});
